import Routes from './Routes';
import './App.css';
import Loader from './components/loader/Loader';
import { useEffect, useState } from 'react';
import api from './utils/api';
import { useDispatch } from 'react-redux';
import { API_ENDPOINT_V1 } from './utils/url';
import { GraphProvider } from './contexts/GraphContext';
import { useTranslation } from 'react-i18next';
import Snackbar from './components/Snackbar';
import { useHistory } from 'react-router-dom';
import React from 'react';

function App() {
  const [isLoaded, setIsLoaded] = useState(false);
  const dispatch = useDispatch();
  const history = useHistory();
  const { i18n } = useTranslation();

  useEffect(() => {
    (async () => {
      const path = window.location.pathname;
      /* if (path.includes('register') || path.includes('login')) {
        setIsLoaded(true);
      } */
      try {
        // const data = await api.get(`${API_ENDPOINT_V1}/auth`);
        // dispatch({
        //   type: 'LOGIN',
        //   payload: data,
        // });
        //history.push('/projects');
      } catch (error) {
        console.log(error);
      } finally {
        setLanguageFromLocalStorage();
        setIsLoaded(true);
      }
    })();
  }, []);

  const setLanguageFromLocalStorage = () => {
    const currentLanguage = localStorage.getItem('lang');
    if (currentLanguage === 'ge') i18n.changeLanguage('ge');
  };

  return (
    <>
      {!isLoaded ? (
        <Loader fullScreen={true} size={undefined} color={undefined} />
      ) : (
        <>
          <Snackbar />
          <GraphProvider>
            <Routes />
          </GraphProvider>
        </>
      )}
    </>
  );
}

export default App;
